import Component from '@glimmer/component'
import { task, timeout } from 'ember-concurrency'
import { InputText } from 'teacher-ui-client/components/base/input-text'
import { queryParam } from 'teacher-ui-client/decorators/query-param'
import { or } from 'ember-truth-helpers'
import { on } from '@ember/modifier'
import pick from 'teacher-ui-client/helpers/pick'
import perform from 'ember-concurrency/helpers/perform'
import { t } from 'ember-intl'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Element: HTMLElement
  Args: {
    placeholder?: string
    themeKey: ThemeKeys
  }
}

export class LessonsSearch extends Component<Signature> {
  @queryParam('subscription-type/lessons') searchQuery!: string

  @queryParam('subscription-type/lessons') pageNumber!: number

  onSearchInput = task({ restartable: true }, async (value: string) => {
    await timeout(200)
    this.searchQuery = value
    this.pageNumber = 1
  }); /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    <InputText
      type="search"
      role="searchbox"
      class="mx-auto block"
      value={{this.searchQuery}}
      placeholder={{or @placeholder (t "pages.product.lessons.searchPlaceholder")}}
      aria-label={{t "pages.product.lessons.searchPlaceholder"}}
      @themeKey={{@themeKey}}
      @icon="search"
      @iconEnd={{true}}
      {{on "input" (pick "target.value" (perform this.onSearchInput))}}
      ...attributes
    />
  </template>
}

export default LessonsSearch
